<template>
	<div
		class="component-upload-image"
		:class="{ 'component-upload-image--cell': compact || cellSize > 0 }"
		:style="cellSizeStyle">
		<el-upload :action="uploadImgUrl" list-type="picture-card" :multiple="multiple"
			:on-success="handleUploadSuccess"
			:before-upload="handleBeforeUpload" :limit="limit" :on-error="handleUploadError" :on-exceed="handleExceed"
			name="file" :before-remove="beforeRemove" :on-remove="handleRemove" :show-file-list="true"
			:file-list="fileList" :on-preview="handlePictureCardPreview"
			:class="{hide: this.fileList.length >= this.limit}">
			<img class="component-upload-bg" src="@/assets/img/upload.png" />
		</el-upload>

		<el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>
			<img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
		</el-dialog>
	</div>
</template>

<script>
	const CDN_BASE = process.env.CDN_BASE || 'http://127.0.0.1:19000/baojia-system';

	export default {
		props: {
			value: [String, Object, Array],
			uploadData: {
				type: Object,
				default: null,
			},
			limit: {
				type: Number,
				default: 5,
			},
			multiple: {
				type: Boolean,
				default: true,
			},
			/** 表格单元格等紧凑场景：缩略图边长（px） */
			cellSize: {
				type: Number,
				default: 0,
			},
			/** 启用紧凑 picture-card 尺寸 */
			compact: {
				type: Boolean,
				default: false,
			},
			fileSize: {
				type: Number,
				default: 5,
			},
			fileType: {
				type: Array,
				default: () => ["png", "jpg", "jpeg"],
			},
			isShowTip: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				dialogImageUrl: "",
				dialogVisible: false,
				baseUrl: CDN_BASE.replace(/\/$/, ''),
				uploadImgUrl: "/addons/minio/index/upload",
				fileList: []
		};
	},
	computed: {
		cellSizeStyle() {
			const size = this.cellSize > 0 ? this.cellSize : (this.compact ? 80 : 0);
			if (!size && !this.compact) return null;
			const px = Math.max(32, size || 80);
			return { '--upload-cell-size': px + 'px' };
		},
	},
	watch: {
			value: {
				handler(val) {
					if (val) {
						const list = Array.isArray(val) ? val : this.value.split(',');
						this.fileList = list.map(item => {
							if (typeof item === "string") {
								const rel = item.indexOf(this.baseUrl) === -1 ? item : item.replace(this.baseUrl, '');
								const url = rel.startsWith('http') ? rel : this.baseUrl + (rel.startsWith('/') ? rel : '/' + rel);
								return { name: url, url };
							}
							return item;
						});
					} else {
						this.fileList = [];
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			beforeRemove() {
				return this.$confirm('确定移除该图片吗？', '提示', {
					confirmButtonText: '移除',
					cancelButtonText: '取消',
					type: 'warning',
				});
			},
			handleRemove(file, fileList) {
				this.fileList = fileList.slice();
				this.$emit("input", this.listToString(this.fileList));
			},
			handleUploadSuccess(res) {
				const payload = res && res.data ? res.data : res;
				const rel = payload.url || payload.key || '';
				const full = payload.fullurl || (this.baseUrl + (rel.startsWith('/') ? rel : '/' + rel));
				this.fileList.push({
					name: full,
					url: full
				});
				this.$emit("input", this.listToString(this.fileList));
				this.loading.close();
			},
			handleBeforeUpload(file) {
				let isImg = false;
				if (this.fileType.length) {
					let fileExtension = "";
					if (file.name.lastIndexOf(".") > -1) {
						fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
					}
					isImg = this.fileType.some(type => {
						if (file.type.indexOf(type) > -1) return true;
						if (fileExtension && fileExtension.indexOf(type) > -1) return true;
						return false;
					});
				} else {
				 isImg = file.type.indexOf("image") > -1;
				}

				if (!isImg) {
					this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`);
					return false;
				}
				if (this.fileSize) {
					const isLt = file.size / 1024 / 1024 < this.fileSize;
					if (!isLt) {
						this.$message.error(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
						return false;
					}
				}
				this.loading = this.$loading({
					lock: true,
					text: "上传中",
					background: "rgba(0, 0, 0, 0.7)",
				});
			},
			handleExceed() {
				this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
			},
			handleUploadError() {
				this.$message({ type: "error", message: "上传失败" });
				this.loading.close();
			},
			handlePictureCardPreview(file) {
				const url = file.url || '';
				const ext = url.split('?')[0].split('.').pop().toLowerCase();
				const isImage = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp'].indexOf(ext) > -1;
				if (!isImage) {
					window.open(url, '_blank');
					return;
				}
				this.dialogImageUrl = url;
				this.dialogVisible = true;
			},
			listToString(list, separator) {
				let strs = "";
				separator = separator || ",";
				list.forEach((item) => {
					let path = item.url || '';
					if (path.indexOf(this.baseUrl) === 0) {
						path = path.slice(this.baseUrl.length);
					}
					if (path && !path.startsWith('/')) path = '/' + path.replace(/^\/+/, '');
					strs += path + separator;
				});
				return strs !== '' ? strs.substr(0, strs.length - 1) : '';
			}
		}
	};
</script>
<style>
	.component-upload-image .component-upload-bg{
		width: 100%;
		height: 100%;
	}
	.component-upload-image .hide .el-upload--picture-card {
		display: none;
	}
	.component-upload-image .el-list-enter-active,
	.component-upload-image .el-list-leave-active {
		transition: all 0s;
	}
	.component-upload-image .el-list-enter,
	.component-upload-image .el-list-leave-active {
		opacity: 0;
		transform: translateY(0);
	}
	.component-upload-image--cell {
		display: inline-flex;
		vertical-align: middle;
		line-height: 1;
		overflow: visible;
	}
	.component-upload-image--cell .el-upload--picture-card,
	.component-upload-image--cell .el-upload-list--picture-card .el-upload-list__item {
		width: var(--upload-cell-size, 80px);
		height: var(--upload-cell-size, 80px);
		margin: 0;
	}
	.component-upload-image--cell .el-upload-list--picture-card {
		display: inline-block;
		margin: 0;
		line-height: 1;
		vertical-align: top;
	}
	.component-upload-image--cell .el-upload-list--picture-card .el-upload-list__item-thumbnail,
	.component-upload-image--cell .el-upload-list--picture-card .el-upload-list__item-actions {
		width: 100%;
		height: 100%;
	}
	.component-upload-image--cell .el-upload--picture-card i {
		font-size: calc(var(--upload-cell-size, 80px) * 0.32);
		line-height: var(--upload-cell-size, 80px);
	}
</style>
